__turbopack_context__.v({
  "progress-bar": "ProgressBar-module__umCfCW__progress-bar",
});
